<style lang="stylus">
    .bottom-panel{
        height: 32px;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-between;
        z-index: 10;
        background var(--bg-color-bottom-panel)
    .line{
        height: 20px;
        width: 1px;
        background: #e0e0e0;
    }

    .page-tabs{
        margin: 0 16px;
        height: 100%;
        min-width: 0;
        flex: 1 1 auto;
        display: flex;
        align-items: center;
        .page-preview-icon{
            position: relative;
            flex-shrink: 0;
            width: 24px;
            height: 24px;
            cursor: pointer;
            margin-right: 8px;
            border-radius: 6px;
            &.active {
                background: rgba(0, 0, 0, .06)
            }
            &:hover {
                background: rgba(0, 0, 0, .04)
            }
            .item-icon{
                width: 24px;
                height: 24px;
                color: var(--svg-color-primary);
                &.active {
                    color: var(--svg-color-active);
                }
            }
        }
        .activeFunc{
                background-color: var(--themeActived)
            }
        .page-drops{
            margin-left: 15px;
            margin-right: 4px;
            width: 108px;
            height: 28px;
            background-color: white;
            position: relative;
            >svg{
                position: absolute;
                width: 12px;
                height: 12px;
                top: 50%;
                left: 80%;
                transform: translate(-50%, -50%);
            }
            .page-actived-name{
                height: 100%;
                cursor: default;
                line-height: 28px;
                text-indent: 12px;
                color: #787878;
            }
            .page-drop-cont{
                position: fixed;
                .page-drop{
                    height:20px;
                }
            }
        }
        .ivu-select{
            margin-right: 2px;
            outline: none;
            .ivu-select-selection{
                box-shadow: none;
                height: 25px !important;
                border: none;
                border-radius: 0;
                .ivu-select-selected-value{
                    font-size: 12px
                    height: 25px !important;
                    line-height: 25px !important;
                }
            }

        }
        .page-names{
            overflow: hidden;
            position: relative;
            display:block;
            height: 100%;
            // max-width: calc(100vw - 600px);

            .scroll-content{
                position: relative;
                display: inline-block;
                height: 100%;
                .all-page-names{
                    width: auto;
                    height: 100%;
                    display:flex;
                    align-items: center;
                    .page-name>div::after{
                        display: block;
                        content: attr(title);
                        font-weight: bold;
                        height: 0;
                        overflow: hidden;
                        visibility: hidden;
                    }
                }
            }

        }
        .page-actived{
            font-size: 13px;
            font-weight: bold;
            color: var(--themeColor);
        }
    }

    .zoom-area{
        flex-shrink: 0;
        height: 32px;
        display: flex;
        align-items: center;
        .ivu-dropdown{
            margin-right: 4px
            .ivu-select-dropdown{
                .ivu-dropdown-item{
                    height: 22px;
                    padding-top: 0;
                    padding-bottom: 0;
                    line-height: 22px;
                }
                .ivu-dropdown-item-divided:before{
                    content: unset;
                }

            }
        }

        .zoom-icon{
            user-select: none;
            width: 10px;
            height:10px;
        }
        .zoom-text {
            margin-left: 12px;
            user-select: none;
            width: 50px;
            height: 20px;
            display: inline-block;
            line-height: 20px;
            position: relative;
            >svg{
            position: absolute;
            width: 10px;
            height: 10px;
            top: 50%;
            left: 80%;
            transform: translate(-50%, -50%);
        }
        }
    }
    .preview-pages{
        transition: all 0s ease 0s;
        transform: translate3d(0px,0px,0px);
        position:absolute;
        bottom: 32px;
        left: 0px;
        right: 0;
        max-height: 400px;

        background-color: var(--bg-color-page-preview-container);
        overflow: hidden;
        .close-previews{
            position: absolute;
            top: 10px;
            right: 10px;
            height: 20px;
            width: 16px;
            >svg{
                width: 100%;
                height: 100%;
                color: var(--svg-color-primary);
                cursor: pointer;
            }
            &:hover{
                background-color: var(--bg-color-float-tool-icon-hover);
            }
        }
        .preview-pages-container{
            max-height: 400px;
            overflow-y: auto;
            .all-preview-pages{
                padding: 10px 30px 10px 10px;
                .selected-page{
                    background-color: var(--bg-color-page-preview-container-selected);
                }
                .preview-page{
                    position: relative;
                    cursor: pointer;
                    border-radius: 3px;
                    float: left;
                    padding: 5px 10px 5px 10px;
                    width: 170px;
                    height: 150px;
                    .pageimg-container{
                        width: 150px;
                        height: 115px;
                        position: relative;
                        >img{
                            display: block;
                            border: 1px solid var(--border-color-right-panel-item-dropbox);
                            border-radius: 4px;
                            width:auto;
                            height:auto;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%,-50%);
                            max-width:100%;
                            max-height:100%;
                        }
                    }

                    .preview-pagename{
                        margin-top: 3px;
                        text-align: center;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                    }
                    .hover-page-icon{
                        pointer-events: auto !important;
                        opacity: 1 !important;
                    }
                    .del-this-page{
                        opacity: 0;
                        pointer-events: none;
                        position: absolute;
                        right: 2px;
                        top: 2px;
                        width: 16px;
                        height: 16px;
                        >svg{
                            stroke: black;
                            width: 100%;
                            height: 100%;
                            color: var(--svg-color-primary)
                        }
                    }
                }

            }
        }
    }
    }
</style>
<style lang="stylus">
    .bottom-panel
        border-top 1px solid var(--border-color-bottom-panel)
        color $right-view-content-textcolor
        .short-line
            width 1px
            height 22px
            background var(--bg-color-bottom-short-line)
            &.pagename-short
                position absolute
                top 6px
                right 0
        .short-line_right
            margin 5px 0
        .page-tabs
            .ivu-select .ivu-icon-ios-arrow-down:before{
                content: "\F116" !important;
            }
            .scroll-button
                display flex
                justify-content center
                align-items center
                width 20px
                height 100%
                background-color var(--bg-color-bottom-more-page)
                color var(--text-color-primary)
                z-index 1
                cursor pointer
                user-select none
                .item-icon
                    width 20px
                    height 20px
                &.hidden
                    width 0
            .ivu-select
                .ivu-select-arrow

                .ivu-select-dropdown
                    padding: 6px
                    .ivu-select-dropdown
                        background-color $dropdown-bkcolor
                    .ivu-select-item
                        border-radius: $box-radius;
                        color fade($dropdown-fontcolor,90%)
                            &:hover
                                background-color $dropdown-hovercolor
                .ivu-select-item-selected
                    color $dropdown-fontcolor
                .ivu-select-selection
                    border: none;
                .ivu-select-selected-value
                    color var(--text-color-primary)
            .page-name
                position relative
                float left
                padding 0 15px
                height 100%
                width auto
                max-width 140px
                cursor default
                overflow hidden
                text-overflow ellipsis
                font-size 12px
                .click-text
                    float left
                    margin-top 2px
                    max-width 100px
                &:hover
                    font-weight bold
            .page-name-content
                color var(--text-color-primary)
                opacity .8
            .page-hidden
                opacity .2
            .add-page
                position relative
                display flex
                justify-content center
                align-items center
                flex-shrink 0
                width 24px
                height 24px
                margin 0 8px
                border-right-color #d0d0d0
                cursor pointer
                border-radius 6px
                .vip-tooltip
                    position absolute
                    bottom 10px
                    right -6px
                    .ivu-tooltip-inner
                        max-width 100%
                        padding 12px 16px
                        border-radius 8px
                        background-color var(--bg-color-tips)
                    .ivu-tooltip-arrow
                        border-top-color var(--border-color-tips)
                    span
                        color #ff7100
                        cursor pointer
                        &:hover
                            text-decoration underline
                &:hover
                    background rgba(0, 0, 0, 0.04)
                .item-icon
                    width 24px
                    height 24px
                    color: var(--svg-color-primary);
            .activeFunc
                background-color var(--themeActived)
        .right-content
            display: flex;
            z-index: 10;
            flex-shrink: 0;
            margin-left: 12px;
            .shape-id
                display flex
                justify-content flex-start
                align-items center
                min-width fit-content
                &::after
                    content ""
                    margin 0 12px
                    width 1px
                    height 65%
                    background-color var(--bg-color-bottom-short-line)
            .vip-clear
                margin-right 8px
                display flex
                justify-content center
                align-items center
                cursor pointer
                &:hover
                    text-decoration underline
                &::after
                    content ""
                    width 1px
                    height 65%
                    margin-left 8px
                    background-color var(--bg-color-bottom-short-line)
                .vip-icon
                    margin-left: 5px;
                    height 12px;
                    width 12px
            // .clear-water-mark
            .shape-count
                position relative
                margin-right 8px
                display flex
                justify-content center
                align-items center
                &::after
                    content ""
                    width 1px
                    height 65%
                    margin-left 8px
                    background-color var(--bg-color-bottom-short-line)
                .vip-tooltip
                    .ivu-tooltip-inner
                        max-width 100%
                        padding 12px 16px
                        border-radius 8px
                        background-color var(--bg-color-tips)
                    .ivu-tooltip-arrow
                        border-top-color var(--border-color-tips)
                    span
                        color #ff7100
                        cursor pointer
                        &:hover
                            text-decoration underline
                .count-info
                    display flex
                    flex-direction column
                    justify-content center
                    margin-right 8px
                    margin-top -2px
                    .count-add
                        color #ff7100
                        cursor pointer
                        margin-left 8px
                        &:hover
                            text-decoration underline
                    .count-process
                        line-height 4px
                        .ivu-progress-outer
                            height 4px
                        .ivu-progress-inner
                            background-color var(--color-black-6)
                            border-radius 250px
                    // iview 进度条组件自带的 status 属性有 bug，使用自定义类覆盖进度条颜色
                    .process-warn
                        .ivu-progress-bg
                            background-color #ed4014
                .count-vip
                    display flex
                    align-items center
                    height 32px

                .vip-icon
                    width 12px
                    height 12px
                    cursor pointer
                .shape-count-float
                    position relative
                    width 304px
                    min-height 138px
                    position absolute
                    bottom 36px
                    left 0
                    .shape-count-float-bg
                        position absolute
                        left 0
                        top 0
                        bottom 0
                        border-radius 8px
                        z-index -1
                        .shape-count-float-image
                            width 100%
                            height 100%
                            border-radius 8px
                        .shape-count-float-icon
                            position absolute
                            right -40px
                            top 55%
                            transform translateY(-50%)
                        .shape-count-float-arrow
                            position absolute
                            left 10px
                            bottom -14px
                    .shape-count-close
                        position absolute
                        right 8px
                        top 8px
                        border-radius 4px
                        width 24px
                        height 24px
                        padding 4px
                        cursor pointer
                        user-select none
                        &:hover
                            background rgba(255, 255, 255, .15)
                        img
                            width 16px
                            height 16px
                    .shape-count-topbar
                        display flex
                        align-items center
                        margin-left 16px
                        margin-top 16px
                        height 18px
                        &.is-sdk
                            img
                                width 20px
                                height 20px
                        img
                            display block
                            width 16px
                            height 16px
                            margin-right 8px
                        p
                            color #fff
                            font-size 14px
                            font-weight 700
                    .shape-count-content
                        color #fff
                        font-size 12px
                        line-height 16px
                        margin-left 16px
                        margin-top 12px
                        .shape-count-contentnum
                            color #FFDD53
                    .shape-count-btn
                        width calc(100% - 32px)
                        height 28px
                        margin 16px
                        background var(--bg-color-float-shape-count-btn)
                        border-radius 6px
                        display flex
                        justify-content center
                        align-items center
                        color #402300
                        font-size 12px
                        font-weight 700
                        cursor pointer
                        user-select none
                        &:hover
                            background var(--bg-color-float-shape-count-btn-hover)



            .zoom-area
                .activeFunc
                    background-color var(--themeActived)
                .ivu-dropdown-rel
                    width: 45px
                    white-space nowrap
                    text-align: right;
                    >a
                        color var(--text-color-primary)
                    .ivu-icon-ios-arrow-down
                        color var(--text-color-primary)
                .ivu-input-number
                    width 70px
                .zoom-input
                    width 96px
                    -webkit-appearance: none !important;
                    border-radius 2px
                    height 3px
                    outline none
                    background #bdbdbd
                    &::-webkit-slider-thumb
                        -webkit-appearance none
                        -moz-appearance none
                        height 12px
                        width 12px
                        border-radius 50%
                        background-color var(--bg-color-zoom-slider-thumb)
                        border 2px solid var(--border-color-zoom-slider)
                        position relative
                        top 0
                        transition all 0.3s
                .zoom-focus
                    display flex
                    align-items center
                    cursor pointer
                    user-select none
                    margin-right 16px
                    svg
                        width 24px
                        height 24px
                        border-radius 6px
                        &.full-icon
                            color: var(--svg-color-primary);
                            &.active
                                color: var(--svg-color-active);

                    p
                        min-width 28px
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                    &:hover svg
                        background rgba(0, 0, 0, 0.04)

                .zoom-sliderbox
                    display flex
                    align-items center
                    .zoom-slider
                        width 24px
                        height 24px
                        cursor pointer
                        margin-right 8px
                        border-radius 6px
                        &:hover
                            background rgba(0, 0, 0, 0.04)
                .zoom-iconbox
                    display flex
                    justify-content center
                    align-items center
                    width 24px
                    height 24px
                    margin-left 6px
                    border-radius 6px
                    .zoom-icon
                        width 16px
                        height 16px
                        cursor pointer
                        color:  var(--svg-color-gray-42);
                    &:hover
                        background rgba(0, 0, 0, 0.04)
                .ivu-dropdown
                    .ivu-select-dropdown
                        background-color $dropdown-bkcolor
                        .ivu-dropdown-item
                            color var(--text-color-primary)
                        .ivu-dropdown-item:hover
                            background-color $dropdown-hovercolor
                .zoom-select
                    display inline-flex
                    align-items center
                    transition all .2s ease-in-out
                .zoom-select_expanded
                    transform rotate(180deg)
                .zoom-100
                    margin-right 12px
                    position relative
                    margin-left 8px
                    opacity 0.7
                    width 24px
                    height 24px
                    cursor pointer
                    border-radius 6px
                    .item-icon
                        width 24px
                        height 24px
                        color: var(--svg-color-primary);
                    &:hover
                        background rgba(0, 0, 0, 0.04)
                .activeFunc
                    background-color var(--themeActived)
    .pageBox-move
        transition all .1s
</style>

<template>
    <div id="bottomPanel" class="bottom-panel" v-click-outside="closePreivew" v-show="expandBottom && $store.state.ui.isOpened">
        <div class="preview-pages" ref="pagePreviews" v-show="showPreviews">
            <div class="preview-pages-container">
                <div class="all-preview-pages">
                    <div
                        v-for="(item, index) in pageNames"
                        :key="index"
                        class="preview-page"
                        @mouseenter="setHoverdPage(index)"
                        @mouseleave="hoverPageIndex = null"
                        @click="setActivePage(index)"
                        :class="{ 'selected-page': index === activedPageIndex }"
                    >
                        <div class="pageimg-container">
                            <img :src="pagePreviewUrls[index]" />
                        </div>
                        <div class="preview-pagename" v-text="item.name"></div>
                        <div class="del-this-page" @click="delThisPage(index)" :class="{ 'hover-page-icon': index === hoverPageIndex }">
                            <iconSymbol name="Del" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="close-previews" @click="showPreviews = false">
                <iconSymbol name="Del" />
            </div>
        </div>
        <div class="page-tabs">
            <div
                class="page-preview-icon"
                v-if="!isPreviewView"
                :class="{ activeFunc: activeFunc == 'previewPage', active: showPreviews }"
                :content="$t('previewPage')"
                v-tippy="{ placement: 'top-start' }"
            >
                <iconSymbol v-if="showPreviews" class="item-icon active" name="showPageThumbActive" @click.native="togglePreviews" />
                <iconSymbol v-else class="item-icon" name="showPageThumb" @click.native="togglePreviews" />
            </div>
            <div class="short-line"></div>
            <i-select v-model="activedPageIndex" @on-change="setActivePage" @on-open-change="openChange" style="width: 124px">
                <i-option v-for="(item, index) in pageNames" class="activePageSelectItem" :value="index" :label="item.name" :key="index"></i-option>
            </i-select>
            <div class="scroll-button" @click="toLeftScroll" :class="{ hidden: !(isScrollable && leftScrollable) }">
                <iconSymbol class="item-icon" :name="'toggle'"></iconSymbol>
            </div>
            <div class="short-line"></div>
            <div id="addpageBtn" class="add-page" v-if="!isPreviewView" @click="toAddPage()" :class="{ activeFunc: activeFunc == 'addPage' }">
                <Tooltip class="vip-tooltip">
                    <VipIcon v-show="pagesLen >= 2 && !vip" @click.stop="showBuyframe('pageIcon')" />
                    <div slot="content">
                        <i18n path="vipTipsPage" tag="p">
                            <span @click.stop="showBuyframe('pageFloat')">{{ $t("vipTipsPageLink") }}</span>
                        </i18n>
                    </div>
                </Tooltip>
                <iconSymbol class="item-icon" :name="'bottomNew'" />
            </div>
            <div class="short-line"></div>
            <div class="page-names" v-if="showIcon" ref="pageScroll" @mousewheel="toScroll">
                <div class="scroll-content">
                    <transition-group class="all-page-names" ref="pageList" tag="div" name="pageBox">
                        <div
                            ref="pageItems"
                            class="page-name"
                            :class="{
                                'page-actived': index === activedPageIndex,
                                'page-hidden': index == hiddenPageIndex,
                            }"
                            v-for="(item, index) in pageNames"
                            :key="item.id"
                            @contextmenu="showContext($event, index)"
                            @mousedown="clickPage($event, index)"
                        >
                            <clickText
                                :ref="'click' + index"
                                :index="index"
                                :text="item.name"
                                v-tippy
                                :content="item.name"
                                @editOK="setPageName"
                                @dbclick.native=""
                            />
                            <div class="short-line pagename-short"></div>
                        </div>
                    </transition-group>
                    <!-- <div v-show="showMoveBox" class="move-page" :style="{'left': `${moveLeft}px`, 'top': `${moveTop}`}">
                    <p>{{ moveName }}</p>
                </div> -->
                </div>
            </div>
            <div class="scroll-button" @click="toRightScroll" :class="{ hidden: !(isScrollable && rightScrollable) }">
                <iconSymbol style="transform: rotate(180deg)" class="item-icon" :name="'toggle'"></iconSymbol>
            </div>
        </div>
        <div class="short-line short-line_right"></div>
        <div class="right-content">
            <div class="clear-water-mark vip-clear" v-if="!vip && isUsedVipState" @click="clearWaterMarkShowBuyfram()">
                <span>{{ $t("clearWatermark") }}</span>
                <VipIcon />
            </div>
            <div class="clear-grid vip-clear" v-if="!vip" @click="clearGrid">
                <span>{{ $t("clearGrid") }}</span>
                <VipIcon />
            </div>
            <div class="shape-count" v-if="showShapeLimit">
                <!-- en promodal -->
                <template v-if="!internal && lang == 'en'">
                    <div class="count-info">
                        <div>
                            {{ `${$t("shapeCount")}: ${shapeCount}/60` }}
                            <Tooltip class="vip-tooltip" :content="'Upgrade to EdrawMax Pro for unlimited shapes'">
                                <span @click.stop="showBuyframe2()" class="count-add">Expand for free</span>
                            </Tooltip>
                        </div>
                        <Progress class="count-process" :class="{ 'process-warn': percent >= 80 }" :percent="percent" :stroke-width="4" hide-info />
                    </div>
                </template>

                <template v-else>
                    <div class="count-info">
                        <div @mouseenter="checkShapeNumFloat">
                            {{ `${$t("shapeCount")}: ${shapeCount}/60` }}
                            <span @click.stop="showBuyframe('symbolsText')" class="count-add">{{ $t("expand") }}</span>
                        </div>
                        <Progress class="count-process" :class="{ 'process-warn': percent >= 80 }" :percent="percent" :stroke-width="4" hide-info />
                    </div>
                    <Tooltip class="vip-tooltip">
                        <div slot="content">
                            <i18n path="vipTipsShape" tag="p">
                                <span @click.stop="showBuyframe('symbolsFloat')">{{ $t("vipTipsShapeLink") }}</span>
                            </i18n>
                        </div>
                        <div class="count-vip">
                            <VipIcon @click.stop="showBuyframe('symbolsIcon')" />
                        </div>
                    </Tooltip>
                </template>

                <div class="shape-count-float" v-if="showShapeNumFloat && !EDCONFIG.IS_SDK">
                    <div class="shape-count-float-bg">
                        <img class="shape-count-float-image" src="@/app/assets/img/bottom/float-bg.png" alt="" />
                        <img class="shape-count-float-icon" src="@/app/assets/img/bottom/float-icon.png" alt="" />
                        <div class="shape-count-float-arrow">
                            <img src="@/app/assets/img/bottom/float-arrow.svg" alt="" />
                        </div>
                    </div>
                    <div class="shape-count-close" @click="closeShapeNum">
                        <img src="@/app/assets/img/bottom/float-close.svg" alt="" />
                    </div>
                    <div class="shape-count-topbar">
                        <img src="@/app/assets/img/bottom/float-vip.svg" alt="" />
                        <p>{{ $t("floatTitle") }}</p>
                    </div>
                    <i18n class="shape-count-content" :path="'floatContent'" tag="p">
                        <span class="shape-count-contentnum">{{ 60 }}</span>
                    </i18n>
                    <div class="shape-count-btn" @click="toBuyVip">{{ $t("floatBtn") }}</div>
                </div>
                <div class="shape-count-float" v-if="showShapeNumFloat && EDCONFIG.IS_SDK">
                    <div class="shape-count-float-bg">
                        <img class="shape-count-float-image" src="@/app/assets/img/bottom/float-bg-sdk.png" alt="" />
                        <div class="shape-count-float-arrow">
                            <img src="@/app/assets/img/bottom/float-arrow-sdk.svg" alt="" />
                        </div>
                    </div>
                    <div class="shape-count-close" @click="closeShapeNum">
                        <img src="@/app/assets/img/bottom/float-close.svg" alt="" />
                    </div>
                    <div class="shape-count-topbar is-sdk">
                        <img src="@/app/assets/img/bottom/float-vip-sdk.svg" alt="" />
                        <p>{{ $t("floatTitleSdk") }}</p>
                    </div>
                    <i18n class="shape-count-content" :path="'floatContentSdk'" tag="p">
                        <span class="shape-count-contentnum">{{ 50 }}</span>
                    </i18n>
                    <div class="shape-count-btn" @click="toBuyVip">7-days free trail</div>
                </div>
            </div>
            <div v-else class="shape-id" v-show="shapeCount != 0">
                {{ `${$t("shapeCount")}: ${shapeCount}` }}
            </div>
            <div class="shape-id" v-show="shapeID != 0 && !isMultisel">
                {{ `${$t("shapeID")}: ${shapeID}` }}
            </div>
            <div class="zoom-area" id="zoomArea">
                <Layer />
                <div
                    class="zoom-focus"
                    id="focusBtn"
                    v-if="!isInclowdz && !isPreviewView && !isPlugin"
                    :content="$t('focus')"
                    v-tippy="{ placement: 'top' }"
                    @click="toFullScreen()"
                >
                    <iconSymbol
                        :name="isFullScreen ? 'fullViewIconActive' : 'fullViewIcon'"
                        :class="isFullScreen ? 'full-icon active' : 'full-icon'"
                    />
                </div>
                <MiniMap />
                <!-- <div class="zoom-sliderbox" :content="$t('pagePresent')" v-tippy="{ placement: 'top' }" v-if="!isPlugin && showIcon">
                    <iconSymbol
                        class="zoom-slider"
                        :class="{ activeFunc: activeFunc == 'menuPageSlice' }"
                        :name="'sliderShowIcon'"
                        @click.native="toShowPageSlider()"
                    />
                </div> -->
                <div class="short-line"></div>
                <InputNumber
                    v-if="manualZoomInput"
                    style="z-index: 1; position: absolute; right: 24px"
                    :max="10"
                    :min="0.1"
                    :active-change="false"
                    v-model="zoomValue"
                    @on-blur="zoomToSpec()"
                    :formatter="(value) => `${parseInt(value * 100)} %`"
                    :parser="(value) => `${parseInt(value) / 100}`"
                ></InputNumber>
                <div class="zoom-iconbox" v-if="showIcon" :class="{ activeFunc: activeFunc == 'smallPage' }">
                    <iconSymbol class="zoom-icon" :name="'bottomReduce'" @click.native="toZoomDown" />
                </div>
                <input
                    class="zoom-input"
                    v-if="showIcon"
                    :style="zoomInputBack"
                    type="range"
                    min="0.1"
                    max="10"
                    step="0.01"
                    @change="zoomEvent($event)"
                    @input="zoomInputEvent($event)"
                    v-model="zoomValue"
                />
                <div class="zoom-iconbox" v-if="showIcon" :class="{ activeFunc: activeFunc == 'bigPage' }">
                    <iconSymbol class="zoom-icon" :name="'bottomAdd'" @click.native="toZoomUp" />
                </div>
                <!-- <div class="zoom-text">
                <div class='zoom-text-value' v-text='zoomPercent' ></div>
                <iconSymbol :name='"TriDown"'></iconSymbol>
            </div> -->
                <Dropdown
                    trigger="custom"
                    :visible="showZoomList"
                    v-click-outside="toCloseZoomList"
                    @click.native="toShowZoomList"
                    @dblclick.native="showManualInput"
                    @on-click="zoomTo"
                    @on-visible-change="zoomDropDown"
                >
                    <a v-tippy :content="$t('zoomTips')">
                        {{ zoomPercent }}
                        <span class="zoom-select" :class="{ 'zoom-select_expanded': showZoomList }">
                            <Icon type="ios-arrow-down"></Icon>
                        </span>
                    </a>
                    <DropdownMenu slot="list">
                        <DropdownItem :name="10" v-text="$t('PageWidth')"></DropdownItem>
                        <DropdownItem :name="11" v-text="$t('WholePage')"></DropdownItem>
                        <DropdownItem
                            :divided="index == 0"
                            v-for="(item, index) in zoomVals"
                            :name="index"
                            v-text="numToPercent(item)"
                            :key="index"
                        ></DropdownItem>
                    </DropdownMenu>
                </Dropdown>
                <div class="zoom-100" :class="{ activeFunc: activeFunc == 'fitPage' }" :content="$t('zoomReset')" v-tippy="{ placement: 'top-end' }">
                    <iconSymbol class="item-icon" name="pageReset" @click.native="zoomResetHandler" />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    declare var egSize: any;
    import clickText from "./Common/ClickEdit.vue";
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import Layer from "./Layer.vue";
    import MiniMap from "./MiniMap.vue";
    import { throttle } from "lodash";

    @Component({
        components: {
            clickText,
            Layer,
            MiniMap,
        },
    })
    export default class BottomPanel extends Vue {
        currentOpePageIndex: number = 0;
        manualZoomInput: boolean = false;
        showZoomList: boolean = false;
        zoomVals = [4, 2, 1.5, 1.25, 1, 0.75, 0.5, 0.25];
        pagePreviewUrls = [];
        hoverPageIndex = null;
        isScrollable = false;
        leftScrollable = false;
        rightScrollable = false;
        limitTipVisible = true;

        hiddenPageIndex: number = -1;

        showZoomListTimer = null;
        toCloseZoomList() {
            if (this.showZoomListTimer) {
                clearTimeout(this.showZoomListTimer);
                this.showZoomListTimer = null;
            }
            this.showZoomList = false;
        }
        toShowZoomList() {
            if (this.showZoomList) {
                this.showZoomList = false;
                return;
            }
            if (this.showZoomListTimer) {
                clearTimeout(this.showZoomListTimer);
                this.showZoomListTimer = null;
            }
            this.showZoomListTimer = setTimeout(() => {
                this.showZoomList = true;
            }, 200);
        }
        showManualInput() {
            console.log(123);
            if (this.showZoomListTimer) {
                clearTimeout(this.showZoomListTimer);
                this.showZoomListTimer = null;
            }
            this.manualZoomInput = true;
        }
        get zoomInputBack() {
            let num = Math.round((this.zoomValue / 10) * 100) + "%";
            if (window.EDCONFIG.DEFAULT_THEME === "dark") {
                return {
                    background: "linear-gradient(to right, #fff " + num + "," + "rgba(255, 255, 255, 0.16) " + num + ")",
                };
            }
            return {
                background: "linear-gradient(to right, #424242 " + num + "," + "#ebebeb " + num + ")",
            };
        }
        setHoverdPage(index: number) {
            if (this.pagesLen === 1 && index === 0) {
                this.hoverPageIndex = null;
            } else {
                this.hoverPageIndex = index;
            }
        }
        toScroll(e) {
            let dom = this.$refs.pageScroll as Element;
            if (e["wheelDelta"] > 0) {
                //chrome 120
                dom.scrollLeft -= 30;
            } else {
                //chrome -120
                dom.scrollLeft += 30;
            }
            this.refreshScroll();
        }
        toLeftScroll() {
            let dom = this.$refs.pageScroll as Element;
            dom.scrollLeft -= 80;
            this.$nextTick(() => {
                this.leftScrollable = !!(dom && dom.scrollLeft !== 0);
                this.rightScrollable = !!(dom && dom.scrollWidth - dom.clientWidth > dom.scrollLeft);
            });
        }
        toRightScroll() {
            let dom = this.$refs.pageScroll as Element;
            dom.scrollLeft += 80;
            this.$nextTick(() => {
                this.leftScrollable = !!(dom && dom.scrollLeft !== 0);
                this.rightScrollable = !!(dom && dom.scrollWidth - dom.clientWidth > dom.scrollLeft);
            });
        }
        closePreivew() {
            this.showPreviews = false;
        }
        zoomEvent(e): void {
            e.target.blur();
        }
        zoomInputEvent(e) {
            if (e && e.target && e.target.value) {
                this.throttleZoom(e.target.value);
            }
        }
        throttleZoom = throttle(function (value) {
            window["_view"]?._tool.endEdit();
            window["_view"]?.zoom(Number(value), false);
        }, 34);
        zoomToSpec() {
            console.log(this.zoomValue);
            window["_view"]?.zoom(this.zoomValue, false);
            this.manualZoomInput = false;
        }
        zoomTo(n: number) {
            if (n == 10) {
                window["_view"]?.fitPageWidth();
            } else if (n == 11) {
                window["_view"]?.fitToWindow();
            } else {
                window["_view"]?.zoom(this.zoomVals[n], false);
            }
        }
        zoomDropDown() {
            window["_view"]?._tool.endEdit();
        }
        toZoomDown(): void {
            this.activeFunc = "";
            window["_view"]?._tool.endEdit();
            window["_view"].zoomDown(0.05, false);
        }
        toZoomUp(): void {
            this.activeFunc = "";
            window["_view"]?._tool.endEdit();
            window["_view"].zoomUp(0.05, false);
        }
        zoomReset(): void {
            this.activeFunc = "";
            window["_view"]?._tool.endEdit();
            window["_view"]?.fitToWindow();
        }
        zoomResetHandler() {
            this.zoomReset();

            this.sensors.track("FitFullScreenButton", {
                Catalogues: "BottomToolbar",
            });
        }
        togglePreviews() {
            if (this.isPreviewView) return; // 群组屏蔽事件
            this.activeFunc = "";
            window["_view"]._tool.endEdit();
            this.showPreviews = !this.showPreviews;
            this.getPagePreviews();

            this.sensors.track("PreviewPage", {
                Catalogues: "BottomToolbar",
            });
        }
        getPagePreviews() {
            let view = window["_view"];
            if (!view) return;
            if (this.showPreviews) {
                view._doc._pages.forEach((item, index) => {
                    let page = view._doc.pageByIndex(index);
                    if (!page) return;
                    page.toBitmap(
                        (e) => {
                            // console.log(e);
                            Vue.set(this.pagePreviewUrls, index, URL.createObjectURL(e));
                        },
                        new egSize(150, 120)
                    );
                });
            } else {
                this.hoverPageIndex = null;
            }
        }
        setPageName(newName: string, index: number) {
            if (newName == this.pageNames[index].name) {
                return;
            }
            let isSame = false;
            isSame = this.pageNames.some((item) => {
                return item.name === newName;
            });
            if (!isSame) {
                let view = window["_view"];
                view.renamePage(index, newName);
            } else {
                (<any>this).$edMessage.warning(this.$t("renameRepeat"));
                let clickname = "click" + index;
                (<any>this.$refs[clickname][0]).renameFail(this.pageNames[index].name, "isSameName");
                // (<any>this.$refs.clickEdit).renameFail(this.fileName, 'isSameName');
            }
        }
        numToPercent(n: number) {
            let val = n.toFixed(2).replace(".", "");
            val = val.replace(/^0*/, "");
            return val + "%";
        }
        get activedThemeId() {
            return this.$store.state.page.activedThemeId;
        }

        get showShapeLimit() {
            if (window.EDCONFIG.IS_SDK) {
                return this.$store.state.ui.isSDKLimitShapeCount;
            }

            return !this.vip;
        }

        toAddPage() {
            if (this.isPreviewView) return; // 群组屏蔽事件
            this.activeFunc = "";
            window["_view"]._tool.endEdit();
            if (this.$store.state.page.pages && this.pagesLen >= 2 && window.EDCONFIG.IS_SDK) {
                if (!this.$checkAuth({ type: "addPage", buyTrigger: "pagePop" })) return;
            }

            let view = window["_view"];
            view.addPage();
            if (window.EDCONFIG.IS_SDK) {
                view.changeTheme(this.activedThemeId, false, true, false);
            }
            if (!this.vip && this.$store.state.page.pages && this.pagesLen >= 2) {
                this.sensors.track("tryVipBenefit", {
                    Catalogues: "editFileProcess",
                    trial_vip_benefit: "pageIcon",
                });
            }
            this.getPagePreviews();

            this.sensors.track("AddPage", {
                Catalogues: "BottomToolbar",
            });
        }
        showBuyframe(type) {
            this.$openBuyPage(type);
        }
        showBuyframe2() {
            this.$store.commit("toPublicStatus", {
                type: "upgradeTrigger",
                data: "symbolsText",
            });
            this.$bus.$emit("togglePromodal", true, 0, 2);
        }
        clearWaterMarkShowBuyfram() {
            let type = "removeVipTemplateMark";
            if (this.isOnlyVipSymbol) {
                type = "removeVipLibraryMark";
            }
            this.$store.commit("toPublicStatus", {
                type: "upgradeTrigger",
                data: type,
            });
            this.showBuyframe(type);
        }
        refreshScroll() {
            let dom = this.$refs.pageScroll as Element;
            this.isScrollable = !!(dom && dom.scrollWidth > dom.clientWidth);
            this.leftScrollable = !!(dom && dom.scrollLeft !== 0);
            this.rightScrollable = !!(dom && dom.scrollWidth - dom.clientWidth > dom.scrollLeft);
        }
        delThisPage(index: number) {
            let view = window["_view"];
            if (this.pagesLen === 1) {
                return;
            }
            view.removePage(index);
        }
        clickPage(e, index) {
            if (e.button == 2) return;
            let pageParent = this.$refs.pageList["$el"] as HTMLElement;
            let dom = this.$refs.pageScroll as Element;
            let parentLeft = pageParent.getBoundingClientRect()["x"];
            let target = e.target,
                pageList = [],
                moveFlag = false,
                baseScrollLeft = dom.scrollLeft,
                clickLeft = e.clientX,
                clickTop = e.clientY,
                clickIndex = index;

            let getWidth = (target, arr) => {
                for (let i = 0; i < target.children.length; i++) {
                    arr.push(target.children[i].getBoundingClientRect().width);
                }
            };
            getWidth(pageParent, pageList);
            let offsetWidth = pageList[index] / 2;
            let crossWidth = 0;
            document.onmousemove = (ev) => {
                let scrollLeft = dom.scrollLeft - baseScrollLeft;
                let moveLeft = ev.clientX,
                    moveTop = ev.clientY;
                if (moveLeft == clickLeft || moveTop == clickTop) {
                    return;
                }
                if (!moveFlag) {
                    this.hiddenPageIndex = index;
                }
                moveFlag = true;
                let offsetX = moveLeft - clickLeft + scrollLeft + crossWidth;

                if (offsetX < 0) {
                    // 左移
                    let num = index;
                    let width = offsetX;
                    for (let i = index; i >= 0; i--) {
                        if (width + pageList[i - 1] < 0 && num > 0) {
                            width += pageList[i - 1];
                            crossWidth += pageList[i - 1];
                            this.hiddenPageIndex = --num;
                            [this.pageNames[i], this.pageNames[i - 1]] = [this.pageNames[i - 1], this.pageNames[i]];
                            [pageList[i], pageList[i - 1]] = [pageList[i - 1], pageList[i]];
                            this.$forceUpdate();
                        } else {
                            index = num;
                            this.hiddenPageIndex = num;
                            break;
                        }
                    }
                } else {
                    // 右移
                    let num = index;
                    let width = offsetX;
                    for (let i = index; i <= pageList.length - 1; i++) {
                        if (width - pageList[i + 1] > 0 && num < pageList.length - 1) {
                            width -= pageList[i + 1];
                            crossWidth -= pageList[i + 1];
                            [this.pageNames[i], this.pageNames[i + 1]] = [this.pageNames[i + 1], this.pageNames[i]];
                            [pageList[i], pageList[i + 1]] = [pageList[i + 1], pageList[i]];
                            this.hiddenPageIndex = ++num;
                            this.$forceUpdate();
                        } else {
                            index = num;
                            this.hiddenPageIndex = num;
                            break;
                        }
                    }
                }
            };
            document.onmouseup = () => {
                !moveFlag && this.setActivePage(index);
                if (moveFlag) {
                    let idArr = this.pageNames.map((item) => {
                        return item.id;
                    });
                    let view = window["_view"];
                    view.reorderPages(idArr);
                }

                this.hiddenPageIndex = -1;

                document.onmouseup = null;
                document.onmousemove = null;
            };
        }
        scrollToPage() {
            this.$nextTick(() => {
                const list = this.$refs.pageItems as any[];
                if (list && list.length > 0) {
                    for (let item of list) {
                        if (item._prevClass.indexOf("actived") > 0) {
                            if (typeof item?.scrollIntoViewIfNeed === "function") {
                                item.scrollIntoViewIfNeeded();
                                break;
                            }
                        }
                    }
                }
            });
        }
        setActivePage(index: number) {
            window["_view"]._tool.endEdit();
            if (index === this.activedPageIndex) {
                return;
            }
            let view = window["_view"];
            // view.changeCurrentPage(index);
            this.activedPageIndex = index;
        }
        openChange() {
            window["_view"]._tool.endEdit();
        }
        showContext(e: MouseEvent, index: number) {
            window["_view"]._tool.endEdit();
            // this.setActivePage(index);
            this.currentOpePageIndex = index;
            this.$store.commit("setStatus", {
                type: "contextPos",
                data: [e.pageX, e.pageY],
            });
            this.$store.commit("setStatus", {
                type: "currentOpePageIndex",
                data: index,
            });
            // this.$store.commit('setStatus',{
            //     type: 'contextLeft',
            //     data: e.pageX
            // })
            this.$store.commit("setStatus", {
                type: "activeContextType",
                data: this.$store.state.ui.contextType.pageBar,
            });
            this.$store.commit("setStatus", {
                type: "showContextMenu",
                data: true,
            });
        }
        // getPreviewUrl(index:number){

        //     let page = view._doc.pageByIndex(index);
        //     if(!page) return;
        //     page.toBitmap((e)=>{
        //         console.log(e);
        //         URL.createObjectURL(e);
        //     },new egSize(180,180))
        // }
        toShowPageSlider() {
            this.$bus.$emit("startPageSlides", 0);
            this.activeFunc = "";
        }

        get pagesLen() {
            return this.$store.state.page.pages.length;
        }
        get showIcon() {
            return !(this.isTeamsApp && !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/));
        }
        get showPreviews() {
            return this.$store.state.ui.showPagePreviews;
        }
        set showPreviews(v: boolean) {
            this.$store.commit("setStatus", {
                type: "showPagePreviews",
                data: v,
            });
        }
        get pageNames() {
            return this.$store.state.page.pages;
        }
        get activedPageIndex() {
            return this.$store.state.page.activedPageIndex;
        }
        @Watch("activedPageIndex", {
            deep: true,
        })
        activedPageIndexChange(newVal, oldVal) {
            if (oldVal !== newVal) {
                const activePageSelectItem = document.getElementsByClassName("activePageSelectItem");
                this.$nextTick(() => {
                    activePageSelectItem[oldVal] && activePageSelectItem[oldVal].classList.remove("ivu-select-item-focus");
                    activePageSelectItem[newVal] && activePageSelectItem[newVal].classList.add("ivu-select-item-focus");
                    this.scrollToPage();
                    setTimeout(() => {
                        this.refreshScroll();
                    }, 300);
                });
            }
        }
        set activedPageIndex(index: number) {
            if (index === this.activedPageIndex) {
                return;
            }
            let view = window["_view"];
            setTimeout(() => {
                view.changeTextCacheToSingleImage(false);
                view.changeCurrentPage(index);
                setTimeout(() => {
                    view.changeTextCacheToSingleImage(true);
                }, 500);
            }, 0);
        }
        // get activedPageName(){
        //     return this.pageNames[this.activedPageIndex];
        // }

        get zoomValue(): number {
            return parseFloat(this.$store.state.ui.zoomValue);
        }
        set zoomValue(n: number) {
            this.$store.commit("setStatus", {
                type: "zoomValue",
                data: n,
            });
        }
        get zoomPercent() {
            let val = this.zoomValue.toFixed(2).replace(".", "");
            val = val.replace(/^0*/, "");
            return val + "%";
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }
        set activeFunc(v) {
            this.$store.commit("setStatus", {
                type: "activeFunc",
                data: v,
            });
        }
        get shapeID() {
            return this.$store.state.shape.id;
        }
        get shapeCount() {
            return this.$store.state.page.shapeCount;
        }
        @Watch("shapeCount")
        watchShapeCount(val) {
            if (window.EDCONFIG.IS_SDK) {
                let localShapeCount50Limit = JSON.parse(localStorage.getItem("localShapeCount50Limit"));
                if (!this.showShapeNumFloat && this.shapeCount > 50 && !this.vip && !localShapeCount50Limit) {
                    this.showShapeNumFloat = true;
                    localStorage.setItem("localShapeCount50Limit", JSON.stringify(true));
                }
            }
        }
        get percent() {
            let numerator = Math.round((this.shapeCount / 60) * 100) < 100 ? Math.round((this.shapeCount / 60) * 100) : 100;
            return numerator;
        }
        get isGroupView() {
            return this.$store.state.ui.isGroupView;
        }
        get isPreviewView() {
            return this.$store.state.ui.isPreviewView;
        }
        get isMultisel() {
            return this.$store.state.shape.isMultiSel;
        }
        get expandBottom() {
            return this.$store.getters.expandBottom;
        }

        isFullScreen = false;
        focusType = "first";
        toFullScreen() {
            if (this.isPreviewView) return;
            this.sensors.track("clickFocus", {
                Catalogues: "Function",
                type: this.focusType,
            });
            this.focusType = "repeat";
            if (document.fullscreenElement || (<any>document).webkitFullscreenElement || (<any>document).msFullscreenElement) {
                this.toCompatExitFullScreen();
            } else {
                this.toCompatFullScreen(document.documentElement);
                this.$store.commit("setStatus", {
                    type: "isFocusMode",
                    data: true,
                });
                this.$store.commit("setStatus", {
                    type: "focusExpand",
                    data: [0, 1, 2, 3],
                });
                if (this.isWorkwx || this.isTeamsApp) {
                    this.$nextTick(() => {
                        window["_view"].onsize();
                    });
                }
            }
            this.activeFunc = "";
        }
        toCompatFullScreen(rootEle) {
            if (rootEle.requestFullscreen) {
                rootEle.requestFullscreen();
            } else if (rootEle.webkitRequestFullscreen) {
                rootEle.webkitRequestFullscreen();
            } else if (rootEle.mozRequestFullScreen) {
                rootEle.mozRequestFullScreen();
            } else if (rootEle.msRequestFullscreen) {
                rootEle.msRequestFullscreen();
            }
        }
        toCompatExitFullScreen() {
            this.exitFocus();
        }
        exitFocus() {
            if (window.EDCONFIG.IS_SDK) {
                return;
            }
            if (this.checkFullScreen()) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if ((<any>document).webkitExitFullscreen) {
                    (<any>document).webkitExitFullscreen();
                } else if ((<any>document).mozExitFullScreen) {
                    (<any>document).mozExitFullScreen();
                } else if ((<any>document).msExitFullscreen) {
                    (<any>document).msExitFullscreen();
                }
            }
            this.$store.commit("setStatus", {
                type: "isFocusMode",
                data: false,
            });
            this.$store.commit("setStatus", {
                type: "fillColorWindow",
                data: false,
            });
            this.$store.commit("setStatus", {
                type: "lineColorWindow",
                data: false,
            });
            this.$store.commit("setStatus", {
                type: "fontColorWindow",
                data: false,
            });
            this.$store.commit("toPalette", { type: null });
        }
        checkFullScreen() {
            let isFull = document.fullscreenElement || (<any>document).webkitFullscreenElement || (<any>document).msFullscreenElement;
            //to fix : false || undefined == undefined
            if (isFull === undefined) {
                isFull = false;
            }
            return !!isFull;
        }

        setIsFullScreen() {
            const isFull = document.fullscreenElement || (<any>document).webkitFullscreenElement || (<any>document).msFullscreenElement;
            this.isFullScreen = !!isFull;
        }
        get isUsedVipState() {
            return this.$store.getters.isUsedVipState;
        }
        get isOnlyVipSymbol() {
            return this.$store.getters.isOnlyVipSymbol;
        }
        get vipStateFuncList() {
            return this.$store.getters.vipStateFuncList;
        }

        clearGrid() {
            let view = window["_view"];
            if (!view) return;
            view.showGridBox(false);
            this.$store.commit("setStatus", {
                type: "removeGrid",
                data: false,
            });
            if (!this.vip) {
                this.sensors.track("tryVipBenefit", {
                    Catalogues: "editFileProcess",
                    trial_vip_benefit: "removeGrid",
                });
            }
            this.$store.commit("setStatus", {
                type: "triggerType",
                data: "removeGrid",
            });
            if (!this.internal && this.lang !== "zh") {
                this.$store.commit("toPublicStatus", {
                    type: "upgradeTrigger",
                    data: "removeGrid",
                });
                this.$bus.$emit("togglePromodal", true, 0, 1);
            } else {
                let list = [];
                list = this.vipStateFuncList.slice();
                list.push("funcGrid");
                this.$bus.$emit("toggleFuncVipTip", { visible: true, vipFuncs: list, upgradeTrigger: "removeGrid" });
            }
        }

        showShapeNumFloat = false;
        customCloseFlag = false;
        closeShapeNum() {
            this.customCloseFlag = true;
            this.showShapeNumFloat = false;
        }
        showShapeNum() {
            if (this.customCloseFlag) return;
            this.showShapeNumFloat = true;
            this.sensors.track("tryVipBenefit", {
                Catalogues: "editFileProcess",
                trial_vip_benefit: "symbolsExceedLimit",
            });
        }
        toBuyVip() {
            this.$openBuyPage("symbolsFloatingWindow");
        }
        checkShapeNumFloat() {
            if (!this.showShapeNumFloat && this.shapeCount > 60) {
                this.showShapeNumFloat = true;
            }
        }

        mounted() {
            this.$bus.$on("exitFocus", () => {
                this.exitFocus();
            });
            let scrollDom = this.$refs.pageScroll as Element;
            this.isScrollable = !!(scrollDom && scrollDom.scrollWidth > scrollDom.clientWidth);
            this.leftScrollable = !!(scrollDom && scrollDom.scrollLeft !== 0);
            this.rightScrollable = !!(scrollDom && scrollDom.scrollWidth - scrollDom.clientWidth > scrollDom.scrollLeft);
            window.addEventListener("resize", () => {
                let scrollDom = this.$refs.pageScroll as Element;
                this.isScrollable = !!(scrollDom && scrollDom.scrollWidth > scrollDom.clientWidth);
                this.leftScrollable = !!(scrollDom && scrollDom.scrollLeft !== 0);
                this.rightScrollable = !!(scrollDom && scrollDom.scrollWidth - scrollDom.clientWidth > scrollDom.scrollLeft);
                if (!this.checkFullScreen()) {
                    this.exitFocus();
                }
            });
            this.scrollToPage();
        }

        beforeDestroy() {
            this.$bus.$off("exitFocus");
            document.removeEventListener("fullscreenchange", this.setIsFullScreen);
        }

        created() {
            this.$bus.$on("refreshPagePre", () => {
                this.getPagePreviews();
            });
            this.$bus.$on("bottomPanelFunc", (type) => {
                if (type == "previewPage") {
                    this.togglePreviews();
                } else if (type == "addPage") {
                    this.toAddPage();
                } else if (type == "smallPage") {
                    this.toZoomDown();
                } else if (type == "bigPage") {
                    this.toZoomUp();
                } else if (type == "fitPage") {
                    this.zoomReset();
                }
            });

            document.addEventListener("fullscreenchange", this.setIsFullScreen);
        }
    }
</script>
<i18n>
{
  "zh": {
    "zoomReset": "适应页面",
    "previewPage": "预览页面",
    "renameRepeat": "命名重复，请换个名字试试",
    "PageWidth": "适应宽度",
    "WholePage": "适应页面",
    "pagePresent": "页面演示",
    "shapeID": "形状ID",
    "shapeCount": "形状数",
    "focus": "专注",
    "zoomTips": "缩放比例。点击打开缩放菜单。",
    "expand": "扩充",
    "vipTipsPage": "页面上限2个，{0}",
    "vipTipsPageLink": "开通VIP尊享页面数量无限",
    "vipTipsShape": "形状上限60个，{0}",
    "vipTipsShapeLink": "开通VIP尊享无限形状",
    "clearWatermark": "去水印",
    "clearGrid": "去网格",
    "floatTitleSdk": "即将超出免费版限制",
    "floatContentSdk": "免费版本最多可添加 {0} 个形状。即将超出限制，开通会员将不限制添加的形状数量。",
    "floatTitle": "已超出免费版的数量限制",
    "floatContent": "免费版本最多可添加 {0} 个形状。现在已经超出限制，开通会员将不限制添加的形状数量。",
    "floatBtn": "开通VIP"
  },
  "en": {
    "zoomReset": "Fit to Whole Page",
    "previewPage": "Preview Page",
    "renameRepeat": "This name already existed, try a different one.",
    "PageWidth": "Page Width",
    "WholePage": "Whole Page",
    "pagePresent": "Present Pages",
    "shapeID": "Shape ID",
    "shapeCount": "Number of shapes",
    "focus": "Focus",
    "zoomTips": "Zoom level. Click to open the Zoom Menu.",
    "expand": "Expand",
    "vipTipsPage": "The maximum number of pages is two. {0}",
    "vipTipsPageLink": "Become a VIP to enjoy an unlimited number of pages",
    "vipTipsShape": "Limited to 60 shapes. {0}",
    "vipTipsShapeLink": "Upgrade to Premium for unlimited shapes.",
    "clearWatermark": "Remove watermarks",
    "clearGrid": "Remove grid",
    "floatTitleSdk": "You'll reach the shape limit ",
    "floatContentSdk": "Free Plan limited 60 symbols per file,you've already set 50 symbols",
    "floatTitle": "Reached the limit",
    "floatContent": "You have reached the free plan limits of {0} shapes. Upgrade to premium to unlock unlimited shapes.",
    "floatBtn": "Upgrade to Premium"
  },
  "jp": {
    "zoomReset": "ページに合わせる",
    "previewPage": "ページプレビュー",
    "renameRepeat": "名前が重複しています。別の名前を試してください",
    "PageWidth": "ページの幅に合わせる",
    "WholePage": "ページに合わせる",
    "pagePresent": "ページプレゼンテーション",
    "shapeID": "シェイプID",
    "shapeCount": "図形の個数",
    "focus": "全画面モード",
    "zoomTips": "ズーム倍率。ズームメニューを開きます。",
    "expand": "Expand",
    "vipTipsPage": "2 ページに制限されています。{0}",
    "vipTipsPageLink": "無制限のページ数を得るには、プレミアムにアップグレードしてください。",
    "vipTipsShape": "60 個の図形に制限されています。{0}",
    "vipTipsShapeLink": "無制限の図形数を得るには、プレミアムにアップグレードしてください。",
    "clearWatermark": "透かしを削除",
    "clearGrid": "グリッドの削除",
    "floatTitle": "上限に達しました",
    "floatContent": "図形の数が無料プランの上限の{0}個に達しました。図形を無制限に利用するには、プレミアムにアップグレードしてください。",
    "floatBtn": "プロ版にアップグレード"
  },
  "fr": {
    "zoomReset": "zoom Réinitialiser",
    "previewPage": "Page d'aperçu",
    "renameRepeat": "Répétition du nom, veuillez essayer un autre nom",
    "PageWidth": "Largeur de page",
    "WholePage": "Page entière",
    "pagePresent": "Démo Page",
    "shapeID": "ID de forme",
    "shapeCount": "Nombre de formes",
    "focus": "Mode Mise au point",
    "zoomTips": "Pourcentage de zoom. Cliquer pour ouvrir le menu Zoom.",
    "expand": "Expand",
    "vipTipsPage": "Limité à deux pages. {0}",
    "vipTipsPageLink": "Passez à la version Premium pour un nombre illimité de pages.",
    "vipTipsShape": "Limité à 60 formes. {0}",
    "vipTipsShapeLink": "Passez à la version Premium pour un nombre illimité de formes.",
    "clearWatermark": "Supprimer les filigranes",
    "clearGrid": "Retirer la grille",
    "floatTitle": "Limite atteinte",
    "floatContent": "Vous avez atteint la limite de {0} formes de la formule gratuite. Passez à la version Premium pour un nombre illimité de formes.",
    "floatBtn": "Mise à niveau vers Edition Professional"
  },
  "de": {
    "zoomReset": "Der ganzen Seite anpassen",
    "previewPage": "Vorschauseite",
    "renameRepeat": "Dieser Name existierte bereits, versuchen Sie einen anderen",
    "PageWidth": "Seitenbreite anpassen",
    "WholePage": "Ganzer Seite anpassen",
    "pagePresent": "Seite präsentieren",
    "shapeID": "Form-ID",
    "shapeCount": "Anzahl an Formen",
    "focus": "Fokus-Modus",
    "zoomTips": "Zoomstufe. Klicken, um das Zoom-Menü zu öffnen.",
    "expand": "Expand",
    "vipTipsPage": "Auf 2 Seiten beschränkt. {0}",
    "vipTipsPageLink": "Führen Sie ein Upgrade auf Premium durch, um eine unbegrenzte Anzahl an Seiten zu nutzen.",
    "vipTipsShape": "Auf 60 Formen beschränkt. {0}",
    "vipTipsShapeLink": "Führen Sie ein Upgrade auf Premium durch, um eine unbegrenzte Anzahl an Formen zu nutzen.",
    "clearWatermark": "Wasserzeichen entfernen",
    "clearGrid": "Raster entfernen",
    "floatTitle": "Das Limit ist erreicht",
    "floatContent": "Sie haben das Limit von {0} Formen für den kostenlosen Tarif erreicht. Führen Sie ein Upgrade auf Premium durch, um eine unbegrenzte Anzahl an Formen zu nutzen.",
    "floatBtn": "Auf Premium Version upgraden"
  },
  "es": {
    "zoomReset": "Ajustar a toda la página",
    "previewPage": "Página de vista previa",
    "renameRepeat": "Este nombre ya existía, pruebe uno diferente",
    "PageWidth": "Ajustar a Ancho de página",
    "WholePage": "Ajustar a toda la página",
    "pagePresent": "Presentación de la página",
    "shapeID": "ID de forma",
    "shapeCount": "Número de formas",
    "focus": "Modo de Enfoque",
    "zoomTips": "Nivel de Zoom. Haz clic para abrir el menú de Zoom.",
    "expand": "Expand",
    "vipTipsPage": "Limitado a 2 páginas. {0}",
    "vipTipsPageLink": "Actualice a Premium para obtener páginas ilimitadas.",
    "vipTipsShape": "Limitado a 60 formas. {0}",
    "vipTipsShapeLink": "Actualice a Premium para obtener formas ilimitadas.",
    "clearWatermark": "Eliminación de marcas de agua",
    "clearGrid": "Eliminar rejilla",
    "floatTitle": "Se ha alcanzado el límite",
    "floatContent": "Has alcanzado el límite del plan gratuito de {0} formas. Actualiza a Premium para desbloquear formas ilimitadas.",
    "floatBtn": "Actualizar a la versión Premium"
  },
  "pt": {
    "zoomReset": "Ajustar para Página Completa",
    "previewPage": "Página de Previsualização",
    "renameRepeat": "Este nome já existe, tentar um nome diferente.",
    "PageWidth": "Largura da Página",
    "WholePage": "Página Completa",
    "pagePresent": "Apresentar páginas",
    "shapeID": "ID da forma",
    "shapeCount": "Número de formas",
    "focus": "Modo de Fóco",
    "zoomTips": "Nível de zoom. Clique para abrir o Menu Zoom.",
    "expand": "Expand",
    "vipTipsPage": "Limitado a 2 páginas. {0}",
    "vipTipsPageLink": "Atualize para a versão Premium para obter páginas sem limites.",
    "vipTipsShape": "Limitado a 60 formas. {0}",
    "vipTipsShapeLink": "Atualize para a versão Premium para obter formatos sem limites.",
    "clearWatermark": "Remover marcas d'água",
    "clearGrid": "Remover grade",
    "floatTitle": "Limite atingido",
    "floatContent": "Você atingiu o limite de {0} formas do plano gratuito. Atualize para a versão Premium para desbloquear formatos ilimitados.",
    "floatBtn": "Fazer upgrade para Versão Premium"
  },
  "it": {
    "zoomReset": "Adatta a Pagina",
    "previewPage": "Anteprima Pagina",
    "renameRepeat": "Questo nome esiste già. Provane un altro.",
    "PageWidth": "Larghezza Pagina",
    "WholePage": "Pagina Intera",
    "pagePresent": "Presentazione Pagine",
    "shapeID": "ID forma",
    "shapeCount": "Numero di forme",
    "focus": "Modalità Focus",
    "zoomTips": "Livello dello zoom.Clicca per aprire il Menu dello Zoom.",
    "expand": "Expand",
    "vipTipsPage": "Al massimo 2 pagine. {0}",
    "vipTipsPageLink": "Passa alla versione Premium per un numero di pagine illimitato",
    "vipTipsShape": "Limitato a 60 forme. {0}",
    "vipTipsShapeLink": "Passa alla versione Premium per forme illimitate",
    "clearWatermark": "Rimuovi filigrana",
    "clearGrid": "Rimuovi griglia",
    "floatTitle": "Limite raggiunto",
    "floatContent": "Hai raggiunto il limite di {0} forme del piano gratuito. Passa alla versione Premium per sbloccare forme illimitate.",
    "floatBtn": "Esegui l'Upgrade alla Versione Premium"
  },
  "tw": {
    "zoomReset": "適合頁面",
    "previewPage": "預覽頁面",
    "renameRepeat": "命名重複，請換個名字試試",
    "PageWidth": "適合寬度",
    "WholePage": "適合頁面",
    "pagePresent": "頁面演示",
    "shapeID": "形狀ID",
    "shapeCount": "形狀數量",
    "focus": "對焦模式",
    "zoomTips": "縮放級別。單擊打開縮放菜單。",
    "expand": "Expand",
    "vipTipsPage": "上限為 2 頁。{0}",
    "vipTipsPageLink": "升級至 Premium 以享有無上限的頁面。",
    "vipTipsShape": "上限為 60 個形狀。{0}",
    "vipTipsShapeLink": "升級至 Premium 以享有無上限的形狀。",
    "clearWatermark": "移除浮水印",
    "clearGrid": "移除格線",
    "floatTitle": "已達上限",
    "floatContent": "您已達到免費方案{0}個形狀的上限。升級至 Premium 即可解鎖無上限的形狀。",
    "floatBtn": "升級VIP會員"
  }
}
</i18n>
